import { FeatureFlags } from '~/modules/feature_flags';
import { EXPLORE_BASE_ROUTE, Routes } from '~/modules/routes';
import { isPluginListingId, isSkillListingId } from '~/modules/utilities/listingIdPatterns';

export const getAppCost = (pricing: string): string => {
    // price_model_type: 'free' | 'freemium' | 'paid' | 'free_to_install';
    return pricing === 'free' ? 'free' : 'paid';
};

export const isAiAssetListing = (listingId?: string, listingType?: string): boolean => {
    const normalizedType = listingType?.trim().toLowerCase();
    return (
        isSkillListingId(listingId) ||
        isPluginListingId(listingId) ||
        normalizedType === 'ai-skill' ||
        normalizedType === 'ai-plugin'
    );
};

/** Skills and Plugins are always free even though their source payloads omit marketplace pricing. */
export const getListingAppCost = (pricing?: string, listingId?: string, listingType?: string): string => {
    return isAiAssetListing(listingId, listingType) ? 'free' : getAppCost(pricing ?? '');
};

export const getAppType = (recordType: string): string => {
    // recordType values: 'Service' | 'App' | 'BoltTemplate' | 'Bot' | 'Component' | 'Content' | 'Data' | 'Flow' | 'Template';
    return recordType === 'Service' ? 'consulting' : 'product';
};

export const isLabs = (publisher: string): boolean => {
    return !!publisher && /Salesforce Labs/.test(publisher);
};

export const getQueryStringValue = (url: string, qsParam: string): string => {
    if (!url || !qsParam) {
        return '';
    }
    const queryString = url.split('?')[1];
    const params = new URLSearchParams(queryString);

    return params.get(qsParam) || '';
};

export const isGA4 = () => {
    return FeatureFlags.FF_GA4_ANALYTICS;
};

const SEARCH_SOURCE_TO_SEARCH_TYPE: Record<string, string> = {
    autoSuggestion: 'autocomplete_suggestion',
    topSearch: 'top_search',
    inlineSuggestion: 'inline_suggestion',
};

export const mapSearchSourceToSearchType = (searchSource?: string): string => {
    if (!searchSource) {
        return 'site';
    }
    return SEARCH_SOURCE_TO_SEARCH_TYPE[searchSource] || 'site';
};

export const determinePageType = (url: string): string => {
    const { pathname } = new URL(url, window.location.origin);

    switch (true) {
        case pathname === '/' || pathname === '':
            return 'Home';
        case pathname.includes(EXPLORE_BASE_ROUTE):
        case pathname === `/${Routes.CONSULTING_HOME}`:
        case pathname === `/${Routes.CONSULTING_HOME}/`:
        case pathname === `/${Routes.JAPANESE_CONSULTING_HOME}`:
        case pathname === `/${Routes.JAPANESE_CONSULTING_HOME}/`:
            return 'Explore';
        case pathname.includes(Routes.SEARCH):
            return 'Search';
        case pathname.includes(Routes.FAVORITE_LISTINGS):
            return 'Favourites';
        case pathname.includes(Routes.LISTING) ||
            pathname.includes(Routes.CONTENT_LISTING) ||
            pathname.includes(Routes.CONSULTANT_LISTING):
            return 'Listing';
        default:
            return '';
    }
};
